import FaceRegisterBox from './FaceRegisterBox';

export default FaceRegisterBox;
